window.mpcBundle = function (currentVariant = null) {
  let purchaseOptions = document.querySelectorAll('.subs-box-options label.option-card > input');
  const mpcBundleOpts = document.querySelector('.mpc-bundles');

  function updateBundleClasses(value) {
    if (!mpcBundleOpts) return;

    const isSubscription = value === 'subscription_op';

    mpcBundleOpts.classList.toggle('subscription-on', isSubscription);
    mpcBundleOpts.classList.toggle('onetime-on', !isSubscription);
  }

  // On page load
  const checkedOption = document.querySelector('.subs-box-options label.option-card > input:checked');
  if (checkedOption) {
    updateBundleClasses(checkedOption.value);

    if (checkedOption.value == 'oneime_op') {
      // update add-on product properties based on the selected variant
      const addOnProductProps = document.querySelectorAll('.add-on-product-prop');
      if (addOnProductProps.length > 0) {
        addOnProductProps.forEach((input) => {
          input.value = `${Date.now()}`;
        });
      }
    } else {
      const addOnProductProps = document.querySelectorAll('.add-on-product-prop');
      if (addOnProductProps.length > 0 && currentVariant) {
        addOnProductProps.forEach((input) => {
          input.value = `${currentVariant.id}-${Date.now()}`;
        });
      }
    }
  }

  purchaseOptions.forEach((input) => {
    input.addEventListener('change', function () {
      updateBundleClasses(this.value);

      if (this.value == 'oneime_op') {
        // update add-on product properties based on the selected variant
        const addOnProductProps = document.querySelectorAll('.add-on-product-prop');
        if (addOnProductProps.length > 0) {
          addOnProductProps.forEach((input) => {
            input.value = `${Date.now()}`;
          });
        }
      } else {
        const addOnProductProps = document.querySelectorAll('.add-on-product-prop');
        if (addOnProductProps.length > 0 && currentVariant) {
          addOnProductProps.forEach((input) => {
            input.value = `${currentVariant.id}-${Date.now()}`;
          });
        }
      }
    });
  });
};

document.addEventListener('DOMContentLoaded', (event) => {
  const initialVariant = window.product_selected_variant;
  window.mpcBundle(initialVariant);
});

window.customOnVariantChange = function (currentVariant = null) {
  const addOnProductProps = document.querySelectorAll('.add-on-product-prop');
  if (addOnProductProps.length > 0) {
    addOnProductProps.forEach((input) => {
      input.value = `${currentVariant.id}-${Date.now()}`;
    });
  }
};

window.addEventListener('load', () => {
  const params = new URLSearchParams(window.location.search);
  if (params.has('variant') || params.has('option_values')) return;
  const picker = document.querySelector('variant-selects[data-bf-default-middle]');
  const middlePack = picker?.querySelectorAll('input[second_option]')[1];
  if (middlePack && !middlePack.checked && !middlePack.disabled) middlePack.click();
});
